import React from 'react'
import TeamImg from '../img/team_project.png'
import PocketSpinnerImg from '../img/pocketSpinner_project.png'
import WeatherImg from '../img/weather-app.png';
import ToDoAppImg from '../img/to-do-app.png';
import QuizAppImg from '../img/quiz-app.png'
import '../style.css'

function Projects() {
    return (
        <div className = 'skills-container'>
        <div className = 'title-block'>
            <h2 className = 'title skills'>Portfolio</h2>
            <h3 className = 'subtitle skills'>My projects</h3>
            <div className = 'line descr skills'></div>
            <div className = 'text portfolio'>(Press on square to redirect to my project)</div>
        </div>
        <div className = 'grid-container portfolio'>
            <div className = 'grid-element portfolio'>
                <a href= 'https://neset-markelov.com'>
                    <img className = 'grid-img' src = {TeamImg} alt = 'team website link'></img>
                </a>
            </div>
            <div className = 'grid-element portfolio'>
                <a href= 'https://pocketspinner.com'>
                    <img className = 'grid-img' alt = 'pocket spinner link' src = {PocketSpinnerImg}></img>
                </a>
            </div>
            <div className = 'grid-element portfolio'>
                <a href= 'https://weather-app-amarkelo.netlify.app'>
                    <img className = 'grid-img' alt = 'weather-app link' src = {WeatherImg}></img>
                </a>
            </div>
            <div className = 'grid-element portfolio'>
                <a href= 'https://to-do-app-amarkelo.netlify.app'>
                    <img className = 'grid-img' alt = 'to-do app link' src = {ToDoAppImg}></img>
                </a>
            </div>
            <div className = 'grid-element portfolio'>
                <a href= 'https://quiz-app-amarkelo.netlify.app'>
                    <img className = 'grid-img' alt = 'quiz app link' src = {QuizAppImg}></img>
                </a>
            </div>
        </div>
    </div>
    )
}

export default Projects;